type QueuedCallT = unknown[]

const MAX_QUEUE_SIZE = 100
const POLL_INTERVAL_MS = 200
const MAX_WAIT_MS = 15_000

let queue: QueuedCallT[] = []
let pollTimer: ReturnType<typeof setInterval> | null = null
let waitedMs = 0

const isGtagReady = () => typeof window !== 'undefined' && typeof window.gtag === 'function'

const flush = () => {
  if (!isGtagReady()) return
  const pending = queue
  queue = []
  for (const args of pending) {
    window.gtag?.(...args)
  }
}

const stopPolling = () => {
  if (pollTimer === null) return
  clearInterval(pollTimer)
  pollTimer = null
}

const startPolling = () => {
  if (pollTimer !== null || typeof window === 'undefined') return
  waitedMs = 0
  pollTimer = setInterval(() => {
    waitedMs += POLL_INTERVAL_MS
    if (isGtagReady()) {
      flush()
      stopPolling()
      return
    }
    if (waitedMs >= MAX_WAIT_MS) {
      queue = []
      stopPolling()
    }
  }, POLL_INTERVAL_MS)
}

export const gtagCall = (...args: QueuedCallT) => {
  if (typeof window === 'undefined') return

  if (isGtagReady()) {
    flush()
    window.gtag?.(...args)
    return
  }

  if (queue.length < MAX_QUEUE_SIZE) queue.push(args)
  startPolling()
}
